import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IGetState } from '../../../../../types/types';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { REST_CHATS } from '../../../../constants';
import { getRestHeadersPost } from '../../../../helpers/getRestHeadersHelper';
import { Util } from '../../../../../util/util';
import { IComment } from '../../../../../store/model/card/types/IComment';

//TODO done
/***
 * Сделами коментарий. теперь надо у всех кто подписан на чат,
 * обновить инфу от последнем коменте и счетчик не процитанных
 * @param comment
 */
export const chatCommentAddedRest = (
    comment: IComment,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IComment>(
            Util.getApiUrl(REST_CHATS + 'chat/commentAdded'), {
                ...getRestHeadersPost(),
                body: JSON.stringify(comment)
            }
        );
    };
    return action;
};
